<template>
    <div class="card-sidebar" style="position:fixed; width: 15%;  height: 99vh; bottom: 0px; left:0px; background: #ffffff; border-top-left-radius: 18px; z-index: 10000;">
        <div class="card-sidebar-head" style="margin-top: -1.8em; margin-bottom: 5px; border-bottom: #eee solid 1px;">
            <a href="/" style="color: #000000; text-transform: capitalize; font-size: 18px; font-weight: bolder; cursor: pointer; text-decoration: none;">
                <!-- <span id="appName" style="margin-left:0px; margin-top: 0.02em; padding-top: 0; display: block;">
                    <span style="font-family:Papyrus, fantasy;">Place Order</span>
                </span> -->
                <img src="/static/assets/images/brand001.png" class="img-responsive"/>
            </a>
            <p style="text-align: right;">easy-peasy</p>
            <!-- <hr/> -->
        </div>
        <div class="card-sidebar-body">
            <div class="card-sidebar-group" style="margin-top: 0em;" v-if="site_user_type == 2">
                <h5 style="color: #999;">store<span style="display: none;">______________</span></h5>
                <div>
                    <li style="float: left;"><a class="card-link" href="#"><i class="fas fa-store"></i><span>Lucas</span></a></li>
                    <li style="float: right;" v-if="(Object.keys(sellpoints).length > 1)"><a class="card-link" style="text-decoration: none;" @click="toggleSingleComponent('showBusinesses')"><i class="fas fa-angle-down"></i></a></li>
                    <div style="clear: both;"></div>
                </div>
                <div id="showBusinesses" style="display: none; margin-left: 1em; margin-top: 0.8em;">
                    <li v-for="(sp,i) in sellpoints" :key="i">
                        <a class="card-link" @click="sellpoint = sp; setSellpoint();"><span><i class="fas fa-arrow-right"></i>{{ sp.business_name }}</span></a>
                    </li>
                </div>
                <hr style="margin-top: 2px; margin-bottom: 0px;"/>
            </div>
            <div class="card-sidebar-group" style="margin-top: 1em;">
                <div>
                    <li v-if="site_user_type == 2"><a class="card-link" href="/dashboard"><i class="fas fa-home"></i><span>Dashboard</span></a></li>
                    <li v-if="site_user_type == 1"><a class="card-link" href="/search"><i class="fas fa-store"></i><span>Order From</span></a></li>
                    <li><a class="card-link" href="#"><i class="fas fa-list"></i><span>Orders</span></a></li>
                    <!-- <li v-if="site_user_type == 2"><a class="card-link" href="#"><i class="fas fa-users"></i><span>Customers</span></a></li> -->
                    <li v-if="site_user_type == 2"><a class="card-link" href="/manage/items"><i class="fas fa-table"></i><span>Items</span></a>
                        <div style="margin-left: 0.32em; margin-top: 0.8em; font-size: smaller;">
                            <li><a class="card-link" href="/manage/items"><span><i class="fas fa-arrow-right"></i>Store Items</span> <i style="display: none;" class="fas fa-angle-right"></i></a></li>
                            <li><a class="card-link" href="/manage/items/regular"><span><i class="fas fa-arrow-right"></i>Regular Items</span> <i style="display: none;" class="fas fa-angle-right"></i></a></li>
                            <li><a class="card-link" href="/manage/items/available"><span><i class="fas fa-arrow-right"></i>Available Items</span> <i style="display: none;" class="fas fa-angle-right"></i></a></li>
                            <li><a class="card-link" href="/manage/items/categories"><span><i class="fas fa-arrow-right"></i>Categories</span></a></li>
                        </div>
                    </li>
                    <li v-if="site_user_type == 1"><a class="card-link" href="#"><i class="fas fa-store"></i><span>Favorites</span></a>
                        <div style="margin-left: 0.3em; margin-top: 0.8em;">
                            <div style="margin-left: 2em; margin-top: 0.8em;" v-if="(Object.keys(customers_details).length > 0)">
                                <li v-for="(fave,fdex) in customers_details" :key="fdex" class="txt-00"><a class="card-link" :href="'/'+fave.customer_business_username"><span style="font-size: 13px; width: 3em;">{{ fave.customer_business_name }} asss hbhhaav bhh vvvf sss</span> <i style="display: none;" class="fas fa-angle-right"></i></a></li>
                                <li><a class="card-link" href="/lists/places"><span style="font-size: 13px;" >All ...</span></a></li>
                            </div>
                            <div v-else style="margin-left: 183em;">
                                <li style="color: #ff0000; font-size: 13px;">None added yet</li>
                                <li><a class="card-link" href="/search"><span style="font-size: 13px;">Add New</span> <i style="display: none;" class="fas fa-angle-right"></i></a></li>
                            </div>
                        </div>
                    </li>
                </div>
            </div>
            <div class="card-sidebar-group" style="margin-top: 2em;">
                <h5 style="color: #999;">more<span style="display: none;">______________</span></h5>
                <div>
                    <li><a class="card-link" href="/settings"><i class="fas fa-gear"></i><span>Settings</span></a></li>
                    <li><a class="card-link" href="/notifications"><i class="fas fa-bell"></i><span>Notifications</span></a></li>
                    <li><a class="card-link" href="/support"><i class="fas fa-support"></i><span>Support</span></a></li>
                </div>
            </div>
        </div>
        <div class="card-sidebar-footer" style="position:fixed; bottom: 5px; background: #ffffff;">
            <div style="margin-bottom: 5px;">
                <div class="card-avatar-circle-xx" style=" text-align:center">
                    <img src="/static/assets/images/dummy-image.png"  style="width:25px; height: 25px; border-radius: 50%;"/>
                </div>
                <div style="text-align: center;">
                    <h4 style="font-size: 14px;">{{ user.user_name }}</h4>
                    <!-- <p style="font-size: 12px;">last seen: Yesterday</p> -->
                    <a href="/settings/profile" class="btn sp-button-02-lt" style="line-height: 0.5; font-size: 12px; background-color: #ffe600;">View Profile</a>
                </div>
            </div>
            <div>
                <p style="font-size: 13px;">&COPY; 2023, Place Order</p>
            </div>
        </div>
    </div>
</template>

<style>
    .txt-00{
        width: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: clip;       
    }
    .card-sidebar-group li {
        list-style: none;
        margin-bottom: 0.6em;
    }
    .card-sidebar-group li i{
        margin-right: 0.8em;
    }
</style>

<script>
    import services from './../../services/service'; // Service Class
    import AccountResources from './../Account/Resources/commonfunctions.js';

    //
    let service = new services();

    export default {
        name: 'DashboardSidebar',
        mixins: [AccountResources],
        data () {
            return {}
        },
    
        components: {},
        methods: {
            preset() {
                this.loading = true;
                //../
                let self = this;
                localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.user = value;
                        self.setSiteUser();
                        self.getCustomerBusinesses(self.user.user_id);
                    }else {
                        self.loading = false;
                        //self.$router.push('/login')
                    }
                });
            },
        },
        created: function(){
            this.preset();
        }
    }
</script>


// WEBPACK FOOTER //
// Sidebar.vue?51cbabd4